/* ============================================================
   ZAOS · tema Shopify — comportamiento (JS sin dependencias)
   Hace lo mismo que los componentes de la web v2: intro (el logo viaja a la cabecera), menú que cae
   desde la barra, desplegables, bolsa lateral con la API de secciones, ficha (galería, colores del
   mismo modelo, tallas, cantidad, agregar), catálogo de corrido con filtros y orden en la URL, reels a
   la vista, comparador de colores, carril de reseñas y la ventana de bienvenida.
   ============================================================ */
(function () {
  "use strict";

  var Z = window.ZAOS || { rutas: {}, textos: {} };
  var T = Z.textos || {};
  var $ = function (sel, raiz) { return (raiz || document).querySelector(sel); };
  var $$ = function (sel, raiz) { return Array.prototype.slice.call((raiz || document).querySelectorAll(sel)); };
  var reducido = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var punteroFino = matchMedia("(hover: hover) and (pointer: fine)").matches;
  var raiz = document.documentElement;

  /* ── Bloqueo del scroll: lo piden el menú, los cajones y la bienvenida ── */
  var bloqueos = 0;
  function bloquear(v) {
    bloqueos = Math.max(0, bloqueos + (v ? 1 : -1));
    document.body.style.overflow = bloqueos ? "hidden" : "";
    if (bloqueos) raiz.setAttribute("data-cubierto", ""); else raiz.removeAttribute("data-cubierto");
  }

  /* ── Cajones (bolsa y filtros) ────────────────────────────── */
  var abiertos = [];
  function abrirCajon(caja) {
    if (!caja || abiertos.indexOf(caja) > -1) return;
    var fondo = $("button[data-cerrar]", caja);
    var panel = $("[data-panel]", caja);
    caja.classList.remove("pointer-events-none");
    caja.inert = false;
    if (fondo) { fondo.classList.remove("opacity-0"); fondo.classList.add("opacity-100"); }
    if (panel) { panel.classList.remove("translate-x-full"); panel.classList.add("translate-x-0"); }
    abiertos.push(caja);
    bloquear(true);
    if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 30);
    caja.dispatchEvent(new CustomEvent("zaos:abierto"));
  }
  function cerrarCajon(caja) {
    var i = abiertos.indexOf(caja);
    if (i < 0) return;
    var fondo = $("button[data-cerrar]", caja);
    var panel = $("[data-panel]", caja);
    caja.classList.add("pointer-events-none");
    caja.inert = true;
    if (fondo) { fondo.classList.add("opacity-0"); fondo.classList.remove("opacity-100"); }
    if (panel) { panel.classList.add("translate-x-full"); panel.classList.remove("translate-x-0"); }
    abiertos.splice(i, 1);
    bloquear(false);
    caja.dispatchEvent(new CustomEvent("zaos:cerrado"));
  }
  document.addEventListener("click", function (e) {
    var cerrar = e.target.closest("[data-cerrar]");
    if (!cerrar) return;
    var caja = cerrar.closest("[data-bolsa], [data-filtros]");
    if (caja) cerrarCajon(caja);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && abiertos.length) cerrarCajon(abiertos[abiertos.length - 1]);
  });

  /* ── Intro: el logo del centro viaja al de la cabecera (FLIP) ── */
  var portada = $("[data-portada]");
  if (portada && raiz.dataset.intro !== "vista") {
    var logoGrande = $("img", portada);
    setTimeout(function () {
      var destino = $("#logo-header img");
      if (logoGrande && destino && !reducido && logoGrande.animate) {
        var a = logoGrande.getBoundingClientRect();
        var b = destino.getBoundingClientRect();
        if (a.width) {
          logoGrande.animate(
            [{ transform: "translate(0,0) scale(1)" }, { transform: "translate(" + (b.left - a.left) + "px, " + (b.top - a.top) + "px) scale(" + b.width / a.width + ")" }],
            { duration: 900, easing: "cubic-bezier(0.7, 0, 0.2, 1)", fill: "forwards" }
          );
        }
      }
    }, 450);
    setTimeout(function () { portada.dataset.fase = "salida"; }, 1450);
    setTimeout(function () { portada.hidden = true; }, 2100);
  } else if (portada) {
    portada.hidden = true;
  }

  /* ── Cabecera: menú que cae, búsqueda y desplegables ──────── */
  var barra = $("[data-barra]");
  var menu = $("[data-menu]");
  var botonesMenu = $$("[data-menu-boton], [data-menu-buscar]");
  var menuAbierto = false;
  var desplegado = null;

  function abrirMenu(v, conBusqueda) {
    if (!menu || v === menuAbierto) return;
    menuAbierto = v;
    if (v) { menu.setAttribute("data-abierto", ""); menu.inert = false; }
    else { menu.removeAttribute("data-abierto"); menu.inert = true; }
    bloquear(v);
    botonesMenu.forEach(function (b) {
      b.setAttribute("aria-expanded", v ? "true" : "false");
      b.setAttribute("aria-label", v ? b.dataset.etiquetaCerrar : b.dataset.etiquetaAbrir);
      var abrir = $("[data-icono-abrir]", b);
      var cerrar = $("[data-icono-cerrar]", b);
      if (abrir) abrir.hidden = v;
      if (cerrar) cerrar.hidden = !v;
    });
    if (v) {
      desplegar(null);
      var campo = $("[data-menu-campo]");
      if (campo && (conBusqueda || matchMedia("(min-width: 1024px)").matches)) setTimeout(function () { campo.focus({ preventScroll: true }); }, 60);
    }
  }
  botonesMenu.forEach(function (b) {
    b.addEventListener("click", function () { abrirMenu(!menuAbierto, b.hasAttribute("data-menu-buscar")); });
  });

  function desplegar(id) {
    desplegado = id;
    $$("[data-desplegar]").forEach(function (b) {
      var abierto = b.dataset.desplegar === id;
      b.setAttribute("aria-expanded", abierto ? "true" : "false");
      if (abierto || b.hasAttribute("data-activo-original")) b.setAttribute("data-activo", ""); else b.removeAttribute("data-activo");
      var caret = $(".caret", b);
      if (caret) caret.classList.toggle("rotate-180", abierto);
    });
    $$("[data-desplegable]").forEach(function (d) { d.hidden = d.dataset.desplegable !== id; });
  }
  $$("[data-desplegar]").forEach(function (b) {
    if (b.hasAttribute("data-activo")) b.setAttribute("data-activo-original", "");
    b.addEventListener("click", function () { desplegar(desplegado === b.dataset.desplegar ? null : b.dataset.desplegar); });
  });
  $$("[data-desplegable] a").forEach(function (a) { a.addEventListener("click", function () { desplegar(null); }); });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (menuAbierto) abrirMenu(false);
    if (desplegado) desplegar(null);
  });
  document.addEventListener("pointerdown", function (e) {
    if (desplegado && barra && !barra.contains(e.target)) desplegar(null);
  });

  /* ── Bolsa (API de secciones) ─────────────────────────────── */
  var bolsa = $("[data-bolsa]");
  function pintarCuenta(n) {
    $$("[data-bolsa-cuenta]").forEach(function (b) { b.textContent = n; b.hidden = !n; });
    $$("[data-abrir-bolsa]").forEach(function (a) {
      a.setAttribute("aria-label", n === 1 ? T.bolsaUno : String(T.bolsa || "").replace("[n]", n));
    });
  }
  function pintarBolsa(html) {
    if (!bolsa || !html) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var nuevo = $("[data-bolsa-panel]", doc);
    var actual = $("[data-bolsa-panel]", bolsa);
    if (!nuevo || !actual) return;
    actual.replaceWith(nuevo);
    pintarCuenta(Number(nuevo.dataset.cuenta || 0));
  }
  function pedir(url, cuerpo) {
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(cuerpo) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }
  function refrescarBolsa() {
    return fetch((Z.rutas.raiz || "/") + "?sections=bolsa", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        pintarBolsa(d && d.bolsa);
        var panel = bolsa && $("[data-bolsa-panel]", bolsa);
        return panel ? Number(panel.dataset.cuenta || 0) : 0;
      })
      .catch(function () { return 0; });
  }
  function agregar(items) {
    return pedir(Z.rutas.agregar, { items: items, sections: "bolsa" }).then(function (d) {
      pintarBolsa(d.sections && d.sections.bolsa);
      abrirCajon(bolsa);
      return d;
    });
  }
  document.addEventListener("click", function (e) {
    var abrir = e.target.closest("[data-abrir-bolsa]");
    if (abrir && bolsa) {
      e.preventDefault();
      if (menuAbierto) abrirMenu(false);
      abrirCajon(bolsa);
      return;
    }
    var linea = e.target.closest("[data-linea]");
    if (linea && bolsa && bolsa.contains(linea)) {
      linea.disabled = true;
      pedir(Z.rutas.cambiar, { id: linea.dataset.linea, quantity: Number(linea.dataset.cantidad), sections: "bolsa" })
        .then(function (d) { pintarBolsa(d.sections && d.sections.bolsa); })
        .catch(function () { linea.disabled = false; return refrescarBolsa(); });
    }
  });

  /* ── Reels: arrancan con el póster; el video se pide después de cargar la página y solo a la
        vista (versión liviana en celular); se pausan fuera de la vista. reduced-motion = póster ── */
  function trasCargar(fn) {
    if (document.readyState === "complete") setTimeout(fn, 0);
    else window.addEventListener("load", function () { setTimeout(fn, 0); }, { once: true });
  }
  var reels = $$("[data-reel]");
  if (reels.length && !reducido && "IntersectionObserver" in window) {
    trasCargar(function () {
      var movil = matchMedia("(max-width: 767px)").matches;
      var ioReel = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (!v.getAttribute("src")) { v.src = (movil && v.dataset.srcMovil) || v.dataset.src; v.preload = "auto"; }
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) v.pause();
        });
      }, { threshold: 0.35 });
      reels.forEach(function (v) { ioReel.observe(v); });
    });
  }

  /* ── Segunda foto de las tarjetas: solo con cursor y cerca de la vista ── */
  function prepararHover(raizBusqueda) {
    if (!punteroFino) return;
    var imgs = $$("img[data-hover-src]", raizBusqueda);
    if (!imgs.length) return;
    var cargar = function (img) {
      img.srcset = img.dataset.hoverSrcset || "";
      img.src = img.dataset.hoverSrc;
      img.removeAttribute("data-hover-src");
    };
    if (!("IntersectionObserver" in window)) { imgs.forEach(cargar); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var img = $("img[data-hover-src]", e.target);
        if (img) cargar(img);
        io.unobserve(e.target);
      });
    }, { rootMargin: "300px 0px" });
    imgs.forEach(function (img) { io.observe(img.parentElement); });
  }
  prepararHover(document);

  /* ── Comparador: la línea que se arrastra revela uno u otro color ── */
  $$("[data-comparador]").forEach(function (c) {
    var rango = $("[data-comparador-rango]", c);
    var a = $("[data-comparador-a]", c);
    var linea = $("[data-comparador-linea]", c);
    if (!rango || !a || !linea) return;
    rango.addEventListener("input", function () {
      var pos = Number(rango.value);
      a.style.clipPath = "inset(0 " + (100 - pos) + "% 0 0)";
      linea.style.left = pos + "%";
    });
  });

  /* ── Reseñas: flechas que se apagan en los extremos ───────── */
  $$("[data-resenas]").forEach(function (sec) {
    var carril = $("[data-resenas-carril]", sec);
    if (!carril) return;
    // las estrellas se encienden una tras otra la primera vez que la sección se ve
    if (!reducido && "IntersectionObserver" in window && $(".estrellas", sec)) {
      sec.dataset.estrellas = "espera";
      var ioEstrellas = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        sec.dataset.estrellas = "vistas";
        ioEstrellas.disconnect();
      }, { threshold: 0.35 });
      ioEstrellas.observe(carril);
    }
    var atras = $('[data-resenas-mover="-1"]', sec);
    var adelante = $('[data-resenas-mover="1"]', sec);
    $$("[data-resenas-mover]", sec).forEach(function (b) {
      b.addEventListener("click", function () {
        carril.scrollBy({ left: Number(b.dataset.resenasMover) * carril.clientWidth, behavior: reducido ? "auto" : "smooth" });
      });
    });
    var primera = carril.firstElementChild;
    var ultima = carril.lastElementChild;
    if (!primera || !ultima || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.target === primera && atras) atras.disabled = e.intersectionRatio > 0.95;
        if (e.target === ultima && adelante) adelante.disabled = e.intersectionRatio > 0.95;
      });
    }, { root: carril, threshold: [0, 0.95, 1] });
    io.observe(primera);
    io.observe(ultima);
  });

  /* ── Ficha ────────────────────────────────────────────────── */
  var ficha = $("[data-ficha]");
  if (ficha) iniciarFicha(ficha);

  function iniciarFicha(f) {
    /* Galería: miniaturas y carril con indicador */
    var carril = $("[data-carril]", f);
    var miniaturas = $$("[data-ir]", f);
    var puntos = $$("[data-puntos] li", f);
    function marcar(i) {
      miniaturas.forEach(function (b, k) { if (k === i) b.setAttribute("aria-current", "true"); else b.removeAttribute("aria-current"); });
      puntos.forEach(function (p, k) {
        p.classList.toggle("bg-tinta", k === i);
        p.classList.toggle("bg-linea", k !== i);
        if (k === i) p.setAttribute("aria-current", "true"); else p.removeAttribute("aria-current");
      });
    }
    if (carril && "IntersectionObserver" in window) {
      var deLado = getComputedStyle(carril).overflowX === "auto";
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) marcar(Number(e.target.dataset.i)); });
      }, deLado ? { root: carril, threshold: 0.6 } : { threshold: 0.5 });
      $$("li", carril).forEach(function (li) { io.observe(li); });
    }
    miniaturas.forEach(function (b) {
      b.addEventListener("click", function () {
        var i = Number(b.dataset.ir);
        var li = $('li[data-i="' + i + '"]', carril);
        if (li) li.scrollIntoView({ behavior: reducido ? "auto" : "smooth", block: "nearest", inline: "center" });
        marcar(i);
      });
    });

    /* Tallas, cantidad y agregar */
    var form = $("form[data-ficha-form], [data-ficha-form]", f) || $("form", f);
    var campoId = $("[data-variante]", f);
    var tallas = $$("[data-talla]", f);
    var etiquetaTalla = $("[data-talla-elegida]", f);
    var errorTalla = $("[data-error-talla]", f);
    var errorCarrito = $("[data-error-carrito]", f);
    var cantidadVer = $("[data-cantidad-ver]", f);
    var cantidad = $("[data-cantidad]", f);
    var boton = $("[data-agregar]", f);
    var necesitaTalla = boton && boton.dataset.necesitaTalla === "true";
    // la cantidad no pasa de las unidades disponibles de la talla (data-max) ni de 9
    var maximo = campoId ? Number(campoId.dataset.max || 9) : 9;
    var menos = $("[data-menos]", f);
    var mas = $("[data-mas]", f);
    function fijarCantidad(n) {
      n = Math.max(1, Math.min(maximo, n));
      if (cantidad) cantidad.value = n;
      if (cantidadVer) cantidadVer.textContent = n;
      if (menos) menos.disabled = n <= 1;
      if (mas) mas.disabled = n >= maximo;
    }
    tallas.forEach(function (b) {
      b.addEventListener("click", function () {
        tallas.forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
        if (campoId) campoId.value = b.dataset.id;
        if (etiquetaTalla) etiquetaTalla.textContent = " " + b.dataset.talla;
        if (errorTalla) errorTalla.hidden = true;
        if (errorCarrito) errorCarrito.hidden = true;
        maximo = Number(b.dataset.max || 9);
        fijarCantidad(Number(cantidad ? cantidad.value : 1));
      });
    });
    fijarCantidad(1);
    if (menos) menos.addEventListener("click", function () { fijarCantidad(Number(cantidad.value) - 1); });
    if (mas) mas.addEventListener("click", function () { fijarCantidad(Number(cantidad.value) + 1); });
    if (form && boton) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (necesitaTalla && !(campoId && campoId.value)) {
          if (errorTalla) errorTalla.hidden = false;
          return;
        }
        if (errorCarrito) errorCarrito.hidden = true;
        boton.disabled = true;
        agregar([{ id: Number(campoId.value), quantity: Number(cantidad ? cantidad.value : 1) }])
          .then(function () {
            boton.textContent = T.agregado;
            setTimeout(function () { boton.textContent = T.agregar; }, 2000);
          })
          .catch(function (err) {
            if (errorCarrito) { errorCarrito.textContent = (err && (err.description || err.message)) || T.errorCarrito; errorCarrito.hidden = false; }
            // Shopify a veces agrega una parte («solo se añadió un artículo»): la bolsa se refresca y se abre si cambió
            var antes = Number(($("[data-bolsa-cuenta]") || {}).textContent || 0);
            return refrescarBolsa().then(function (n) { if (n > antes) abrirCajon(bolsa); });
          })
          .then(function () { boton.disabled = false; });
      });
    }
    // «Comprar ahora»: agrega el par sin abrir el carrito y va directo al pago (con lo que ya hubiera en el carrito)
    var ahora = $("[data-comprar-ahora]", f);
    if (ahora && campoId) {
      ahora.addEventListener("click", function () {
        if (necesitaTalla && !campoId.value) {
          if (errorTalla) errorTalla.hidden = false;
          return;
        }
        if (errorCarrito) errorCarrito.hidden = true;
        ahora.disabled = true;
        if (boton) boton.disabled = true;
        ahora.textContent = T.yendoAlPago;
        pedir(Z.rutas.agregar, { items: [{ id: Number(campoId.value), quantity: Number(cantidad ? cantidad.value : 1) }] })
          .then(function () { window.location.href = Z.rutas.pagar; })
          .catch(function (err) {
            if (errorCarrito) { errorCarrito.textContent = (err && (err.description || err.message)) || T.errorCarrito; errorCarrito.hidden = false; }
            ahora.textContent = T.comprarAhora;
            ahora.disabled = false;
            if (boton) boton.disabled = false;
            return refrescarBolsa();
          });
      });
      // al volver con «atrás» la página sale de la caché con el botón en «Yendo al pago…»
      window.addEventListener("pageshow", function (e) {
        if (!e.persisted) return;
        ahora.textContent = T.comprarAhora;
        ahora.disabled = false;
        if (boton) boton.disabled = false;
      });
    }

    /* Colores del mismo modelo: se buscan en la tienda y se queda uno por color */
    var lista = $("[data-colores]", f);
    var modelo = f.dataset.modelo;
    var termino = f.dataset.termino;
    if (!lista || !modelo || !termino) return;
    var url = (Z.rutas.buscar || "/search") + "?type=product&options%5Bprefix%5D=last&section_id=" + encodeURIComponent(f.dataset.seccionColores || "colores") + "&q=";
    var traer = function (q) {
      return fetch(url + encodeURIComponent(q)).then(function (r) { return r.ok ? r.text() : ""; }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        return $$("[data-colores-resultados] a", doc).filter(function (a) { return a.dataset.modelo === modelo && a.dataset.handle !== f.dataset.handle; });
      });
    };
    traer("title:" + termino)
      .then(function (r) { return r.length ? r : traer(termino); })
      .then(function (hermanos) {
        hermanos.sort(function (a, b) { return String(b.dataset.creado).localeCompare(String(a.dataset.creado)); });
        var vistos = {};
        vistos[f.dataset.color] = true;
        var elegidos = [];
        hermanos.forEach(function (a) {
          if (vistos[a.dataset.color] || elegidos.length >= 7) return;
          vistos[a.dataset.color] = true;
          elegidos.push(a);
        });
        elegidos.forEach(function (a) {
          var li = document.createElement("li");
          var enlace = document.createElement("a");
          enlace.href = a.getAttribute("href");
          enlace.className = "block size-14 overflow-hidden border border-linea bg-pared transition-colors hover:border-tinta";
          enlace.title = a.dataset.color;
          enlace.setAttribute("aria-label", String(T.verEn || "").replace("[color]", a.dataset.color));
          if (a.dataset.img) {
            var img = document.createElement("img");
            img.src = a.dataset.img;
            img.alt = "";
            img.width = 56;
            img.height = 56;
            img.loading = "lazy";
            img.className = "size-full object-cover";
            enlace.appendChild(img);
          }
          li.appendChild(enlace);
          lista.appendChild(li);
        });
        var alterno = $("[data-agotado-alterno]", f);
        if (alterno && elegidos.length) {
          alterno.innerHTML = "";
          var otro = document.createElement("a");
          otro.href = elegidos[0].getAttribute("href");
          otro.className = "enlace";
          otro.textContent = String(T.mismoModelo || "").replace("[color]", elegidos[0].dataset.color.toLowerCase());
          alterno.appendChild(otro);
        }
      })
      .catch(function () {});
  }

  /* ── Catálogo: todas las páginas de corrido, filtros y orden en la URL ── */
  var catalogo = $("[data-catalogo]");
  if (catalogo) iniciarCatalogo(catalogo);

  function iniciarCatalogo(c) {
    var grilla = $("[data-grilla]", c);
    var vacio = $("[data-vacio]", c);
    var cuenta = $("[data-cuenta]", c);
    var selOrden = $("[data-ordenar]", c);
    var botonFiltrar = $("[data-abrir-filtros]", c);
    var cajon = $("[data-filtros]", c);
    var ver = $("[data-ver]", c);
    var disp = $("[data-disp]", c);
    var sinAltura = c.hasAttribute("data-sin-altura");
    var params = new URLSearchParams(location.search);
    var estado = {
      altura: params.get("altura") || "",
      color: params.get("color") || "",
      talla: params.get("talla") || "",
      disp: params.get("disp") === "1",
      orden: params.get("orden") || ""
    };
    var tramos = (Z.tramos || []).map(function (l) {
      var p = String(l).trim().split("|");
      return p.length === 4 ? { slug: p[0].trim(), nombre: p[1].trim(), desde: Number(p[2]), hasta: Number(p[3]) } : null;
    }).filter(Boolean);
    function tramoDe(cm) {
      if (cm === "" || cm == null || isNaN(Number(cm))) return null;
      cm = Number(cm);
      for (var i = 0; i < tramos.length; i++) if (cm >= tramos[i].desde && cm <= tramos[i].hasta) return tramos[i].slug;
      return null;
    }
    function items() { return $$(":scope > li", grilla); }
    function datos(li) { return $("[data-tarjeta]", li) ? $("[data-tarjeta]", li).dataset : {}; }
    items().forEach(function (li, i) { li.dataset.pos = i; });

    function pasa(d) {
      if (estado.altura && tramoDe(d.altura) !== estado.altura) return false;
      if (estado.color && d.color !== estado.color) return false;
      if (estado.talla && String(d.tallas || "").indexOf("," + estado.talla + ",") < 0) return false;
      if (estado.disp && d.disp !== "1") return false;
      return true;
    }
    function aplicar() {
      var lista = items();
      var visibles = 0;
      lista.forEach(function (li) {
        var ok = pasa(datos(li));
        li.hidden = !ok;
        if (ok) visibles++;
      });
      var o = estado.orden;
      var ordenada = lista.slice().sort(function (a, b) {
        var da = datos(a), db = datos(b);
        if (o === "menor") return Number(da.precio) - Number(db.precio) || a.dataset.pos - b.dataset.pos;
        if (o === "mayor") return Number(db.precio) - Number(da.precio) || a.dataset.pos - b.dataset.pos;
        if (o === "altura") return (da.altura === "" ? 99 : Number(da.altura)) - (db.altura === "" ? 99 : Number(db.altura)) || a.dataset.pos - b.dataset.pos;
        if (o === "nuevo") return String(db.creado).localeCompare(String(da.creado)) || a.dataset.pos - b.dataset.pos;
        return a.dataset.pos - b.dataset.pos;
      });
      ordenada.forEach(function (li) { grilla.appendChild(li); });
      if (cuenta) cuenta.textContent = visibles + " " + (visibles === 1 ? T.articulo : T.articulos);
      grilla.hidden = !visibles;
      if (vacio) vacio.hidden = !!visibles;
      var activos = [estado.altura, estado.color, estado.talla, estado.disp ? "1" : ""].filter(Boolean).length;
      if (botonFiltrar) botonFiltrar.textContent = T.filtrar + (activos ? " (" + activos + ")" : "");
      if (ver) ver.textContent = String(T.ver || "").replace("[n]", visibles);
      $$("[data-limpiar]", cajon).forEach(function (b) { b.hidden = !activos; });
      if (disp) disp.checked = estado.disp;
      if (selOrden) selOrden.value = estado.orden;
      pintarChips();
      var q = new URLSearchParams(location.search);
      ["altura", "color", "talla", "orden"].forEach(function (k) { if (estado[k]) q.set(k, estado[k]); else q.delete(k); });
      if (estado.disp) q.set("disp", "1"); else q.delete("disp");
      q.delete("page");
      var nueva = location.pathname + (q.toString() ? "?" + q.toString() : "") + location.hash;
      if (nueva !== location.pathname + location.search + location.hash) history.replaceState(null, "", nueva);
    }

    function chip(texto, on, alClic, clase) {
      var li = document.createElement("li");
      var b = document.createElement("button");
      b.type = "button";
      b.className = clase || "chip";
      b.setAttribute("aria-pressed", on ? "true" : "false");
      b.addEventListener("click", alClic);
      if (typeof texto === "string") b.textContent = texto; else b.appendChild(texto);
      li.appendChild(b);
      return li;
    }
    function pintarChips() {
      if (!cajon) return;
      var todos = items().map(datos);
      var gAltura = $('[data-grupo="altura"] [data-chips]', cajon);
      if (gAltura) {
        gAltura.innerHTML = "";
        tramos.forEach(function (t) {
          var n = todos.filter(function (d) { return tramoDe(d.altura) === t.slug; }).length;
          if (!n) return;
          var frag = document.createDocumentFragment();
          frag.appendChild(document.createTextNode(t.nombre + " "));
          var s = document.createElement("span");
          s.className = "num opacity-60";
          s.textContent = n;
          frag.appendChild(s);
          gAltura.appendChild(chip(frag, estado.altura === t.slug, function () { estado.altura = estado.altura === t.slug ? "" : t.slug; aplicar(); }));
        });
        gAltura.closest("fieldset").hidden = !gAltura.children.length;
      }
      var gColor = $('[data-grupo="color"] [data-chips]', cajon);
      if (gColor) {
        gColor.innerHTML = "";
        var colores = {};
        todos.forEach(function (d) {
          if (!d.color) return;
          colores[d.color] = colores[d.color] || { nombre: d.color, hex: d.hex, n: 0 };
          colores[d.color].n++;
        });
        Object.keys(colores).map(function (k) { return colores[k]; }).sort(function (a, b) { return b.n - a.n; }).forEach(function (col) {
          var frag = document.createDocumentFragment();
          var punto = document.createElement("span");
          punto.className = "size-3.5 rounded-full border border-tinta/15";
          punto.style.background = col.hex;
          punto.setAttribute("aria-hidden", "true");
          frag.appendChild(punto);
          frag.appendChild(document.createTextNode(col.nombre));
          gColor.appendChild(chip(frag, estado.color === col.nombre, function () { estado.color = estado.color === col.nombre ? "" : col.nombre; aplicar(); }, "chip flex items-center gap-2"));
        });
      }
      var gTalla = $('[data-grupo="talla"] [data-chips]', cajon);
      if (gTalla) {
        gTalla.innerHTML = "";
        var tallas = {};
        todos.forEach(function (d) { String(d.tallas || "").split(",").forEach(function (t) { if (/^\d{2}$/.test(t)) tallas[t] = true; }); });
        Object.keys(tallas).sort().forEach(function (t) {
          gTalla.appendChild(chip(t, estado.talla === t, function () { estado.talla = estado.talla === t ? "" : t; aplicar(); }, "chip-talla"));
        });
        gTalla.closest("fieldset").hidden = !gTalla.children.length;
      }
    }

    if (selOrden) selOrden.addEventListener("change", function () { estado.orden = selOrden.value; aplicar(); });
    if (disp) disp.addEventListener("change", function () { estado.disp = disp.checked; aplicar(); });
    $$("[data-limpiar]", c).forEach(function (b) {
      b.addEventListener("click", function () { estado.altura = estado.color = estado.talla = ""; estado.disp = false; aplicar(); });
    });
    if (botonFiltrar && cajon) {
      botonFiltrar.addEventListener("click", function () { abrirCajon(cajon); botonFiltrar.setAttribute("aria-expanded", "true"); });
      cajon.addEventListener("zaos:cerrado", function () { botonFiltrar.setAttribute("aria-expanded", "false"); });
    }

    /* Trae las páginas que siguen (sección sola) y las suma a la grilla */
    var seccion = c.closest(".shopify-section");
    var idSeccion = seccion ? seccion.id.replace("shopify-section-", "") : "";
    function siguiente(url) {
      if (!url || !idSeccion) return Promise.resolve();
      var u = url + (url.indexOf("?") > -1 ? "&" : "?") + "section_id=" + encodeURIComponent(idSeccion);
      return fetch(u).then(function (r) { return r.ok ? r.text() : ""; }).then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var otra = $("[data-grilla]", doc);
        if (otra) {
          var base = items().length;
          $$(":scope > li", otra).forEach(function (li, i) { li.dataset.pos = base + i; grilla.appendChild(li); });
        }
        var mas = $("[data-catalogo]", doc);
        return siguiente(mas && mas.dataset.siguiente);
      });
    }
    aplicar();
    // las páginas que siguen se piden cuando la primera ya pintó, para no competir con sus fotos
    trasCargar(function () {
      siguiente(c.dataset.siguiente).then(function () { aplicar(); prepararHover(grilla); }).catch(function () {});
    });
  }

  /* ── Ventana de bienvenida ────────────────────────────────── */
  var bienvenida = $("[data-bienvenida]");
  if (bienvenida && !Z.editor) {
    var CLAVE = "zaos-bienvenida";
    var dias = Number(bienvenida.dataset.dias || 7);
    var estadoB = bienvenida.dataset.estado;
    var abiertaB = false;
    // la foto va en un canvas (no cuenta como contenido principal de la página): se dibuja como object-fit: cover
    var lienzo = $("canvas[data-foto-bienvenida]", bienvenida);
    var foto = null;
    var pintarFoto = function () {
      if (!lienzo || !foto || !foto.naturalWidth) return;
      // tamaño de diseño (offset*): getBoundingClientRect daría el de la animación de entrada (escala 0,98)
      var ancho = lienzo.offsetWidth, alto = lienzo.offsetHeight;
      if (!ancho || !alto) return;
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      lienzo.width = Math.round(ancho * dpr);
      lienzo.height = Math.round(alto * dpr);
      var escala = Math.max(lienzo.width / foto.naturalWidth, lienzo.height / foto.naturalHeight);
      var w = foto.naturalWidth * escala, h = foto.naturalHeight * escala;
      var c = lienzo.getContext("2d");
      c.imageSmoothingQuality = "high";
      c.drawImage(foto, (lienzo.width - w) / 2, (lienzo.height - h) / 2, w, h);
    };
    var cargarFoto = function () {
      if (!lienzo || foto) return;
      foto = new Image();
      foto.decoding = "async";
      foto.onload = pintarFoto;
      foto.src = lienzo.dataset.fotoBienvenida;
    };
    window.addEventListener("resize", function () { if (abiertaB) pintarFoto(); });
    var abrirB = function () {
      if (abiertaB) return;
      abiertaB = true;
      bienvenida.hidden = false;
      cargarFoto();
      requestAnimationFrame(pintarFoto);
      bloquear(true);
      var campo = $("[data-campo-bienvenida]", bienvenida);
      if (campo) setTimeout(function () { campo.focus({ preventScroll: true }); }, 350);
    };
    var cerrarB = function () {
      if (!abiertaB) return;
      abiertaB = false;
      bienvenida.hidden = true;
      bloquear(false);
      try { localStorage.setItem(CLAVE, String(Date.now())); } catch (e) {}
    };
    $$("[data-cerrar-bienvenida]", bienvenida).forEach(function (b) { b.addEventListener("click", cerrarB); });
    var copiar = $("[data-copiar-codigo]", bienvenida);
    if (copiar) copiar.addEventListener("click", function () {
      var codigo = ($("[data-codigo-bienvenida]", bienvenida) || {}).textContent || "";
      var listo = function () { var antes = copiar.textContent; copiar.textContent = copiar.dataset.textoCopiado; setTimeout(function () { copiar.textContent = antes; }, 2200); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(codigo.trim()).then(listo).catch(function () {});
      else {
        var t = document.createElement("textarea");
        t.value = codigo.trim();
        document.body.appendChild(t);
        t.select();
        try { document.execCommand("copy"); listo(); } catch (e) {}
        t.remove();
      }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && abiertaB) cerrarB(); });
    /* Nombre y celular → campos ocultos que lee Shopify (ver snippets/bienvenida). Se validan al escribir
       (setCustomValidity) y no en el submit: el captcha de Shopify también escucha el submit y reenvía
       el formulario aunque otro lo cancele. */
    var campoNombre = $("[data-nombre-bienvenida]", bienvenida);
    var campoCel = $("[data-celular-bienvenida]", bienvenida);
    var etiquetas = $("[data-etiquetas-bienvenida]", bienvenida);
    var etiquetasBase = etiquetas ? etiquetas.value : "";
    // 10 dígitos (celular, o fijo con su 60X) → +57…; si empieza con + se respeta el indicativo
    var celularE164 = function (v) {
      var txt = String(v || "").trim();
      var d = txt.replace(/\D/g, "");
      if (txt.charAt(0) === "+") return d.length >= 8 && d.length <= 15 ? "+" + d : "";
      if (d.length === 12 && d.indexOf("57") === 0) d = d.slice(2);
      return d.length === 10 ? "+57" + d : "";
    };
    var sincronizarDatos = function () {
      if (campoNombre) {
        var partes = campoNombre.value.trim().split(/\s+/);
        $("[data-nombre-1]", bienvenida).value = partes.shift() || "";
        $("[data-nombre-2]", bienvenida).value = partes.join(" ");
      }
      if (campoCel) {
        var cel = celularE164(campoCel.value);
        campoCel.setCustomValidity(cel || !campoCel.value.trim() ? "" : T.errorCelular);
        $("[data-celular-e164]", bienvenida).value = cel;
        if (etiquetas) etiquetas.value = etiquetasBase + (cel ? ", cel " + cel : "");
      }
    };
    [campoNombre, campoCel].forEach(function (c) { if (c) c.addEventListener("input", sincronizarDatos); });
    var form = bienvenida.closest("form");
    if (form) form.addEventListener("submit", function () { try { localStorage.setItem(CLAVE, String(Date.now())); } catch (e) {} });
    if (estadoB === "listo" || estadoB === "error") {
      abrirB();
    } else if (location.search.indexOf("nointro") < 0) {
      var visto = 0;
      try { visto = Number(localStorage.getItem(CLAVE) || 0); } catch (e) {}
      if (Date.now() - visto >= dias * 864e5) {
        trasCargar(cargarFoto);
        setTimeout(abrirB, raiz.dataset.intro !== "vista" ? 3400 : 1400);
      }
    }
  }
})();
